import { render, staticRenderFns } from "./navbarResetPassword.vue?vue&type=template&id=4b08ac7a"
import script from "./navbarResetPassword.vue?vue&type=script&lang=js"
export * from "./navbarResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports